import React, { useContext } from "react";
import Modal from "react-bootstrap/Modal";

import { PrProfileContext } from "../../data/pr_profile_context_management";
import usePrEmploymentsApi from "../../data/use_pr_employments_api";
import ServerErrorAlert from "../../../profiles/ServerErrorAlert";
import EmploymentEditorActive from "./EmploymentEditorActive";

const EMPLOYMENT_ERROR_LABELS = { started_at: "Start date", ended_at: "End date", title: "Title" };

// Reads the employment collection + plumbing straight from PrProfileContext (the provider owns the
// collection now — no modal-local fetch or loading state) and performs writes via use_pr_employments_api.
// Same context-based shape as HeaderModalBody.
function EmploymentForm({ close }) {
  const context = useContext(PrProfileContext);
  const { employments, generalError, isUpdating } = context;
  const { addEmployment, removeEmployment, setFeatured, updateEmployment } = usePrEmploymentsApi({ ...context });

  const employmentState = { employments, addEmployment, removeEmployment, setFeatured, updateEmployment, isUpdating };

  return (
    <>
      <Modal.Body>
        <ServerErrorAlert generalError={generalError} labelMap={EMPLOYMENT_ERROR_LABELS} />
        <EmploymentEditorActive employmentState={employmentState} />
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={close}>
          Close
        </button>
      </Modal.Footer>
    </>
  );
}

export default EmploymentForm;
